import React from 'react';
import classNames from 'classnames';
import pt from 'prop-types';

import Tooltip from 'components/tooltip';

export default class IconHelpLink extends React.PureComponent {
  static propTypes = {
    hoverable: pt.bool,
    hint: pt.string,
    maxTextLineWidth: pt.number,
  };

  render() {
    const { hoverable, hint, maxTextLineWidth } = this.props;

    const content = (
      <span
        className={classNames('icon', 'icon-info', 'icon-help-link', {
          hoverable: Boolean(hoverable),
        })}
      >
        &nbsp;
      </span>
    );

    if (hint) {
      return (
        <Tooltip
          side="bottom"
          message={hint}
          maxTextLineWidth={maxTextLineWidth}
          sideOffset={10}
          arrow
        >
          {content}
        </Tooltip>
      );
    }

    return content;
  }
}
